import React from "react";
import { TrendButtons } from "../trendLab/TrendButtons";
import { Typography } from "@mui/material";
import SupportImg1 from "../../assets/images/SupportImg1.png";
import { SupportHamburger } from "./SupportHamburger";
import { SupportHeader } from "./SupportHeader";

export const SupportIntro = () => {
  const menu2 = [
    { id: 0, title: "Home" },
    { id: 1, title: "Portfolio" },
    { id: 2, title: "TREND Lab" },
  ];
  const trendHeadbtn = [
    {
      id: 0,
      title: "Lets Connect",
    },
  ];
  const supportBtn = [{ id: 0, title: "Contribute", action: "https://www.paypal.com/ncp/payment/TCE2ZEFZ8APNQ" }];

  return (
    <>
      <div className="z-0 supportBgImg1">
        <div
          className="hidden lg:block"
          style={{ position: "", top: 0, zIndex: 50 }}
        >
          <SupportHeader menu1={menu2} headbutton1={trendHeadbtn} />
        </div>
        <div className="lg:hidden ">
          <SupportHamburger />
        </div>
        <div
          className="flex flex-col-reverse items-center justify-between mx-auto text-white 2xl:flex-row"
          style={{ maxWidth: "80%" }}
        >
          <div className="w-full mx-10 2xl:w-1/2">
            <Typography
              className="mt-20 2xl:pt-20"
              style={{
                fontSize: 48,
                fontWeight: 600,
                fontFamily: "Montserrat",
              }}
            >
              Promote Brain
              <br /> Resilience: Rally as a<br /> TREND Ambassador
            </Typography>

            <Typography
              className="my-5"
              style={{
                fontSize: 16,
                fontWeight: 400,
                fontFamily: "Montserrat",
              }}
            >
              Dr. Ali Jawaid and TREND lab are on a mission to combine science
              with compassionate causes. Our science is funded very well from
              several European grants. However, we always go the extra mile in
              our endeavors- we support children affected by trauma through
              direct aid, we give scholarships to deserving students who work
              with us, and we regularly organize public awareness seminars on
              transgenerational trauma and mental health. Unfortunately, these
              humanitarian causes are not covered by scientific grants.
            </Typography>
            <Typography
              className="my-5"
              style={{
                fontSize: 16,
                fontWeight: 400,
                fontFamily: "Montserrat",
              }}
            >
              We invite you to be a part of our mission. You can become a TREND
              ambassador by donating to our humanitarian causes. For donations
              above 100 Euros, you will receive a TREND ambassador T-shirt. For
              donations above 250 Euros, you will get a TREND ambassador T-shirt
              and will have the unique opportunity to learn either of the
              following from Dr. Ali Jawaid - epigenetics, transgenerational
              trauma, stress relief, statistical analysis, scientific
              communication, or scientific writing. A donation of 500 Euros or
              more will combine it all.
            </Typography>

            <div className="mb-48">
              <TrendButtons Tbutton1={supportBtn} />
            </div>
          </div>
          <div className="h-[378px] 2xl:w-1/2 mb-0 md:mb-28">
            <img className="w-full h-full" src={SupportImg1} alt="Support" />
          </div>
        </div>
      </div>
    </>
  );
};
